import React from 'react';

import Loader from '../../../../common/Loader';
import Icon from '../../../../Icon';

import styles from './index.styl';

export const EmptyDataWrapper = ({
  pending,
  children,
  isDataEmpty,
  formatMessage,
}) => (
  <div>
    {pending && <Loader />}
    {!pending && isDataEmpty && (
      <div className={styles.empty}>
        <Icon name="ico-1000-graph" size={60} />

        <div className={styles.description}>
          <div>
            {formatMessage({
              id: 'patient.portal.healthRecord.emptyState.nothingFound',
            })}
          </div>
          <div>
            {formatMessage({
              id: 'patient.portal.healthRecord.emptyState.tryToChoose',
            })}
          </div>
        </div>
      </div>
    )}
    {!pending && !isDataEmpty && children}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/EmptyWrapper/index.jsx